import { configurationSettings } from '../../../configuration/configuration-settings';
import { getMemberHash } from '../../../domains/loyalty/selectors/member/get-member-hash';
export const getCxmRequestContext = (entityType, componentId, maximumFilms) => {
    const { enabled, salesChannelId, filmTerritoryShortCode } = configurationSettings.data.cxm;
    return {
        entityType,
        componentId,
        isCxmIntegrationEnabled: enabled,
        memberIdHash: getMemberHash(),
        maximumFilms,
        salesChannelId,
        filmTerritoryShortCode
    };
};
